import { Suspense } from 'react';
import { CharacteristicValuesList } from './CharacteristicValuesList';
import { CharacteristicValuesListStub } from './CharacteristicValuesListStub';
import { type CharacteristicValuesListProps } from './types';

export function CharacteristicValuesListSuspense(props: CharacteristicValuesListProps) {
    return (
        <Suspense fallback={<CharacteristicValuesListStub />}>
            <CharacteristicValuesList {...props} />
        </Suspense>
    );
}
